import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import Layout from '../../components/Layout'
import Header from '../../components/shared/Header';
import './ManifestCompanies.scss';
import Search from '../../components/shared/Search';
import Modal from '../../components/shared/Modal';
import { loadingActions, filterActions } from '../../redux/actions';
import enterprisesAPI from '../../api/enterprisesAPI';
import AnotherSessionModal from '../../components/shared/AnotherSessionModal';
import { sessionError } from '../../utils/sessionError';

const ManifestCompanies = () => {
  const [modalSession, setModalSession] = useState(false)
  const [textSearch, setTextSearch] = useState('')
  const [showModal, setShowModal] = useState(false)
  const [modalDelete, setModalDelete] = useState(false)
  const [modalError, setModalError] = useState(false)
  const [companies, setCompanies] = useState([])
  const [selectedCompany, setSelectedCompany] = useState(null)
  const dispatch = useDispatch()

  const fetchCompanies = async () => {
    try {
      dispatch(loadingActions.setLoading(true))
      const data = await enterprisesAPI.getEnterprises()
      setCompanies(data)
      dispatch(loadingActions.setLoading(false))
    } catch(e) {
      console.log(e)
      dispatch(loadingActions.setLoading(false))
      if (sessionError(e)) {
        setModalSession(true)
      } else {
        setModalError(true)
      }
    }
  }

  useEffect(() => {
    fetchCompanies()
    // CLEAN FILTERS FROM ALL OTHER TABS
    dispatch(filterActions.cleanAll());
    // eslint-disable-next-line
  }, [])

  const addItem = async item => {
    try {
      dispatch(loadingActions.setLoading(true))
      const enterprise = await enterprisesAPI.createEnterprise(item.companyName, item.companyRuc)
      setCompanies([...companies, {
        id: enterprise.id,
        name: item.companyName,
        ruc: item.companyRuc
      }])
      dispatch(loadingActions.setLoading(false))
      setShowModal(false)
      setSelectedCompany(null)
    } catch(e) {
      console.log(e)
      dispatch(loadingActions.setLoading(false))
      if (sessionError(e)) {
        setModalSession(true)
      }
    }
  }

  const updateItem = async item => {
    try {
      dispatch(loadingActions.setLoading(true))
      await enterprisesAPI.updateEnterprise(selectedCompany.id, item.companyName, item.companyRuc)
      const tempCompanies = [...companies]
      const itemIndex = tempCompanies.findIndex(company => company.id === selectedCompany.id)
      tempCompanies[itemIndex] = {
        id: selectedCompany.id,
        name: item.companyName,
        ruc: item.companyRuc
      }
      setCompanies(tempCompanies)
      dispatch(loadingActions.setLoading(false))
      setShowModal(false)
      setSelectedCompany(null)
    } catch(e) {
      dispatch(loadingActions.setLoading(false))
      if (sessionError(e)) {
        setModalSession(true)
      }
    }
  }

  const deleteItem = async () => {
    try {
      dispatch(loadingActions.setLoading(true))
      await enterprisesAPI.deleteEnterprise(selectedCompany.id)
      const filteredCompanies = companies.filter(company => company.id !== selectedCompany.id)
      setCompanies(filteredCompanies)
      dispatch(loadingActions.setLoading(false))
      setModalDelete(false)
      setSelectedCompany(null)
    } catch(e) {
      dispatch(loadingActions.setLoading(false))
      if (sessionError(e)) {
        setModalSession(true)
      }
    }
  }

  const including = a => {
    return a.toUpperCase().includes(textSearch.toUpperCase())
  }

  const renderData = () => {
    const filteredData = companies.filter(company => including(company.name) || including(company.ruc))
    return filteredData.map(company => (
      <div key={company.id} className='company-item'>
        <div className='company-info'>
          <h2>{company.name}</h2>
          <p>RUC:<span>{company.ruc}</span></p>
        </div>
        <div className='company-buttons'>
          <div onClick={() => {
            setSelectedCompany(company)
            setShowModal(true)
          }}>
            <img src={require('../../../assets/icons/edit.svg')} alt='editar' />
          </div>
          <div onClick={() => {
            setSelectedCompany(company)
            setModalDelete(true)
          }}>
            <img src={require('../../../assets/icons/delete.svg')} alt='borrar' />
          </div>
        </div>
      </div>
    ))
  }

  return (
    <Layout>
      <AnotherSessionModal isOpen={modalSession} onClose={() => setModalSession(false)} />
      {showModal && (
        <Modal
          visible={showModal}
          onClose={() => setShowModal(false)}
          selectedCompany={selectedCompany}
          title={selectedCompany ? 'Editar empresa existente' : 'Agregar nueva empresa'}
          fields={['companyName', 'companyRuc']}
          btn1={{
            text: 'Cancelar',
            type: 'secondary',
            onClick: () => {
              setShowModal(false)
              setSelectedCompany(null)
            }
          }}
          btn2={{
            text: 'Aceptar',
            type: 'primary',
            onClick: data => {
              selectedCompany ? updateItem(data) : addItem(data)
            }
          }}
        />
        )
      }
      {modalDelete && (
        <Modal
          visible={modalDelete}
          onClose={() => setModalDelete(false)}
          title='¿Deseas eliminar esta empresa?'
          color='var(--ripley-salmon)'
          btn1={{
            text: 'Cancelar',
            type: 'secondary',
            onClick: () => {
              setModalDelete(false)
              setSelectedCompany(null)
            }
          }}
          btn2={{
            text: 'Eliminar',
            type: 'primary',
            onClick: () => {
              deleteItem()
            }
          }}
        >
          <div className='modal-delete-company'>
            <p>Vas a borrar</p>
            <p className='modal-delete-company-name'>{selectedCompany.name}</p>
            <p className='modal-delete-company-ruc'>RUC {selectedCompany.ruc}</p>
          </div>
        </Modal>
        )
      }
      <Modal
        visible={modalError}
        onClose={() => {}}
        title='No hay conexión'
        titleImage={require('../../../assets/icons/ic_disconnected.svg')}
        color='var(--ripley-salmon)'
        btn1={{
          text: 'Volver',
          type: 'secondary',
          onClick: () => {
            setModalError(false)
          }
        }}
        btn2={{
          text: 'Reintentar',
          type: 'primary',
          onClick: () => {
            setModalError(false)
            fetchCompanies()
          }
        }}
      >
        <div className='modal-error'>
          <p>Revisa tu conexión a internet e inténtalo de nuevo</p>
        </div>
      </Modal>
      <div className='manifest-companies-container'>
        <div className='manifest-companies-container-head'>
          <Header
            title='Manifiestos'
            subtitle='Empresas'
            onClickBtn1={() => setShowModal(true)}
            btnTitle1='Agregar'
          />
          <div className='companies-search-container'>
            <Search
              placeholder='Nombre de empresa o RUC'
              value={textSearch}
              onChange={text => setTextSearch(text)}
            />
          </div>
        </div>
        <div className='manifest-companies-container-list'>
          {renderData()}
        </div>
      </div>
    </Layout>
  )
}

export default ManifestCompanies
